import {
    aclLink,
    batchAclLink,
    cameraGroupLink,
    cameraLink,
    createSuperAdminsLink,
    createUserLink,
    crossAgencyListLink,
    recordLink,
    superAdminLink,
    userGroupLink,
    userLink,
    videoStatusLink
} from '../../router/routerLink';

export const recordingsTabs = [
    {
        value: 'recordedvideos',
        label: 'Recorded Videos',
        status: 'playback',
        sub: ['recordedvideos'],
        routes: [recordLink] 
    },
    {
        value: 'videostatus',
        label: 'Video Status',
        status: 'playback',
        sub: ['videostatus'],
        routes: [videoStatusLink]
    }
]
export const userTabs = [
    {
        value: 'list',
        label: 'User Management',
        status: 'users',
        sub: ['list', 'createUsers'],
        routes : [userLink, createUserLink]
      },
      {
        value: 'groups',
        label: 'Group Management',
        status: 'users',
        sub: ['groups'],
        routes: [userGroupLink]
      }
]
export const cameraTabs = [
    {
        value: 'list',
        label: 'Camera Management',
        status: 'cameras',
        sub: ['list'],
        routes: [cameraLink]
      },
      {
        value: 'groups',
        label: 'Group Management',
        status: 'cameras',
        sub: ['groups'],
        routes: [cameraGroupLink]
      }
]
export const aclTabs = [
    {
        value: 'accessControl',
        label: 'Access Control List',
        status: 'access',
        sub: ['accessControl'],
        routes: [aclLink]
    },
    {
        value: 'batchAccessControl',
        label: 'Batch Access Control',
        status: 'access',
        sub: ['batchAccessControl'],
        routes: [batchAclLink]
    }
]
export const superAdminTabs = [
    {
        value: 'list',
        label: 'Super Admin Management',
        status: 'superAdmin',
        sub: ['list', 'createSuperAdmin' ],
        routes : [superAdminLink, createSuperAdminsLink]
    },
    {
        value: 'crossAgencylist',
        label: 'Cross Agency Management',
        status: 'superAdmin',
        sub: ['crossAgencylist'],
        routes: [crossAgencyListLink]
    }
]
